<template>
  <aside class="dashboard-nav" :class="{ 'is-collapsed': collapsed && canCollapse }">
    <div class="dashboard-nav-items">
      <button
        type="button"
        class="dashboard-nav-action dashboard-nav-expandable"
        :class="{ 'is-active': activePanel === 'projects' }"
        @click="$emit('toggle-panel', 'projects')"
        :title="s__('Dashboard|Projects')"
      >
        <span class="dashboard-nav-icon"><NetworkIcon variant="inherit" /></span>
        <span class="dashboard-nav-title">{{ s__('Dashboard|Projects') }}</span>
        <NavMetaStateIcon :state="activePanel === 'projects' ? 'expanded' : 'collapsed'" />
      </button>

      <button
        type="button"
        class="dashboard-nav-action dashboard-nav-expandable"
        :class="{ 'is-active': activePanel === 'tasks' }"
        @click="$emit('toggle-panel', 'tasks')"
        :title="s__('Dashboard|Tasks')"
      >
        <span class="dashboard-nav-icon"><ActivityIcon /></span>
        <span class="dashboard-nav-title">{{ s__('Dashboard|Tasks') }}</span>
        <NavMetaStateIcon :state="activePanel === 'tasks' ? 'expanded' : 'collapsed'" />
      </button>

      <a
        :href="calendarUrl"
        class="dashboard-nav-action dashboard-nav-link"
        :title="s__('Dashboard|Calendar')"
      >
        <span class="dashboard-nav-icon"><CalendarIcon /></span>
        <span class="dashboard-nav-title">{{ s__('Dashboard|Calendar') }}</span>
        <NavMetaStateIcon state="open" />
      </a>

      <button
        v-if="boardsEnabled"
        type="button"
        class="dashboard-nav-action dashboard-nav-expandable"
        :class="{ 'is-active': activePanel === 'boards' }"
        @click="$emit('toggle-panel', 'boards')"
        :title="s__('Boards|My boards')"
      >
        <span class="dashboard-nav-icon"><KanbanIcon /></span>
        <span class="dashboard-nav-title">{{ s__('Boards|My boards') }}</span>
        <NavMetaStateIcon :state="activePanel === 'boards' ? 'expanded' : 'collapsed'" />
      </button>

      <button
        v-if="s3AttachmentsEnabled"
        type="button"
        class="dashboard-nav-action dashboard-nav-expandable"
        :class="{ 'is-active': activePanel === 'attachments' }"
        @click="$emit('toggle-panel', 'attachments')"
        :title="s__('Attachments|My files')"
      >
        <span class="dashboard-nav-icon"><FileIcon /></span>
        <span class="dashboard-nav-title">{{ s__('Attachments|My files') }}</span>
        <NavMetaStateIcon :state="activePanel === 'attachments' ? 'expanded' : 'collapsed'" />
      </button>

      <button
        type="button"
        class="dashboard-nav-action dashboard-nav-expandable"
        :class="{ 'is-active': activePanel === 'reports' }"
        @click="$emit('toggle-panel', 'reports')"
        :title="__('Report Constructor')"
      >
        <span class="dashboard-nav-icon"><ReportIcon /></span>
        <span class="dashboard-nav-title">{{ __('Report Constructor') }}</span>
        <NavMetaStateIcon :state="activePanel === 'reports' ? 'expanded' : 'collapsed'" />
      </button>

      <a
        :href="profileUrl"
        class="dashboard-nav-action dashboard-nav-link"
        :title="s__('Profile|Profile')"
      >
        <span class="dashboard-nav-icon"><CircleUserIcon /></span>
        <span class="dashboard-nav-title">{{ s__('Profile|Profile') }}</span>
        <NavMetaStateIcon state="open" />
      </a>
    </div>

    <div class="dashboard-nav-bottom-controls">
      <DashboardNavCornerControls
        :can-toggle-full-width="canToggleFullWidth"
        :is-full-width="isFullWidth"
        :can-collapse="canCollapse"
        :collapsed="collapsed"
        @toggle-full-width="$emit('toggle-full-width')"
        @toggle-collapse="$emit('toggle-collapse')"
      />
    </div>
  </aside>
</template>

<script setup>
import { __, s__ } from '@/locale'
import ActivityIcon from '../common/icons/ActivityIcon.vue'
import CalendarIcon from '../common/icons/CalendarIcon.vue'
import CircleUserIcon from '../common/icons/CircleUserIcon.vue'
import DashboardNavCornerControls from '../common/DashboardNavCornerControls.vue'
import FileIcon from '../common/icons/FileIcon.vue'
import KanbanIcon from '../common/icons/KanbanIcon.vue'
import NetworkIcon from '../common/icons/NetworkIcon.vue'
import NavMetaStateIcon from '../common/NavMetaStateIcon.vue'
import ReportIcon from '../common/icons/ReportIcon.vue'

defineProps({
  activePanel: {
    type: String,
    default: null,
  },
  collapsed: {
    type: Boolean,
    default: false,
  },
  canCollapse: {
    type: Boolean,
    default: false,
  },
  isFullWidth: {
    type: Boolean,
    default: false,
  },
  canToggleFullWidth: {
    type: Boolean,
    default: false,
  },
  boardsEnabled: {
    type: Boolean,
    default: false,
  },
  s3AttachmentsEnabled: {
    type: Boolean,
    default: false,
  },
  calendarUrl: {
    type: String,
    required: true,
  },
  profileUrl: {
    type: String,
    required: true,
  },
})

defineEmits(['toggle-panel', 'toggle-collapse', 'toggle-full-width'])
</script>

<style scoped>
.dashboard-nav {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dashboard-nav-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
